module.exports = __webpack_public_path__ + "img/logo.1c2882c9.svg";